import React from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import AwardeesELe from '../Scholarships/AwardeesELe'


function Main() {
    return (
      <>
          <Header/>
        <Breadcrumb title="Home" subtitle="Awardees"/>
        <AwardeesELe />
      </>
    )
  }
  
  export default Main